'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionPricing = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display:grid;\n  justify-content: center;\n  align-content: center;\n  padding: 0.5em;\n  background-color: rgba(0,0,0,.2);\n  min-height: 4.5em;\n  width: 100%;\n  font-weight: 300;\n\n  & > div {\n    font-size: 0.9em;\n    font-weight: 100;\n    & strong {\n      font-size: 1.5em;\n      margin: 0.2em;\n    }\n    & span {\n      font-size: 1.1em;\n      margin: 0.5em;\n    }\n  }\n\n  & > small {\n    display: block;\n    line-height: 1.4em;\n    margin-top: 0.5em;\n    font-size: 0.75em;\n  }\n'], ['\n  display:grid;\n  justify-content: center;\n  align-content: center;\n  padding: 0.5em;\n  background-color: rgba(0,0,0,.2);\n  min-height: 4.5em;\n  width: 100%;\n  font-weight: 300;\n\n  & > div {\n    font-size: 0.9em;\n    font-weight: 100;\n    & strong {\n      font-size: 1.5em;\n      margin: 0.2em;\n    }\n    & span {\n      font-size: 1.1em;\n      margin: 0.5em;\n    }\n  }\n\n  & > small {\n    display: block;\n    line-height: 1.4em;\n    margin-top: 0.5em;\n    font-size: 0.75em;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    position: relative;\n    display: grid;\n    grid-template-rows: 2fr 4fr;\n    align-items: center;\n    justify-items: center;\n\n    & > strong {\n      font-size: 1em;\n    }\n\n    & ', '{\n      font-size: 0.95em;\n    }\n'], ['\n    position: relative;\n    display: grid;\n    grid-template-rows: 2fr 4fr;\n    align-items: center;\n    justify-items: center;\n\n    & > strong {\n      font-size: 1em;\n    }\n\n    & ', '{\n      font-size: 0.95em;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: block;\n  @media ', ' {\n    display: grid;\n  }\n\n  & > div {\n    margin-top: 1em;\n    font-size: 0.7em;\n    line-height: 1.4em;\n  }\n  & table {\n    margin: 0 auto;\n    table-layout: fixed;\n    width: 100%;\n    display:block;\n    overflow-x: auto;\n    @media ', ' {\n      overflow-x: unset;\n      width: auto;\n    }\n\n    & thead {\n      th {\n        color: white;\n        min-width: 11em;\n\n        &:nth-child(2) {\n          background-color: #F48C37;\n        }\n        &:nth-child(3) {\n            background-color: #21b3a7;\n        }\n        &:nth-child(4) {\n            background-color: #24a9bd;\n        }\n      }\n    }\n\n    & tbody {\n      background-color: white;\n      text-align: center;\n      padding: 15px 0;\n\n      td {\n          padding: 15px;\n\n          &:first-child {\n              text-align: right;\n              font-size: 0.8em;\n              line-height: 1.4em;\n              @media ', ' {\n                font-size: 1em;\n              }\n          }\n      }\n\n      tr {\n\n          &:first-child td {\n              padding-top: 25px;\n          }\n\n          &:last-child td {\n              padding-bottom: 25px;\n          }\n      }\n    }\n\n    & tfoot {\n        text-align: center;\n        & ', ' {\n          margin-top: 10px;\n        }\n    }\n  }\n'], ['\n  display: block;\n  @media ', ' {\n    display: grid;\n  }\n\n  & > div {\n    margin-top: 1em;\n    font-size: 0.7em;\n    line-height: 1.4em;\n  }\n  & table {\n    margin: 0 auto;\n    table-layout: fixed;\n    width: 100%;\n    display:block;\n    overflow-x: auto;\n    @media ', ' {\n      overflow-x: unset;\n      width: auto;\n    }\n\n    & thead {\n      th {\n        color: white;\n        min-width: 11em;\n\n        &:nth-child(2) {\n          background-color: #F48C37;\n        }\n        &:nth-child(3) {\n            background-color: #21b3a7;\n        }\n        &:nth-child(4) {\n            background-color: #24a9bd;\n        }\n      }\n    }\n\n    & tbody {\n      background-color: white;\n      text-align: center;\n      padding: 15px 0;\n\n      td {\n          padding: 15px;\n\n          &:first-child {\n              text-align: right;\n              font-size: 0.8em;\n              line-height: 1.4em;\n              @media ', ' {\n                font-size: 1em;\n              }\n          }\n      }\n\n      tr {\n\n          &:first-child td {\n              padding-top: 25px;\n          }\n\n          &:last-child td {\n              padding-bottom: 25px;\n          }\n      }\n    }\n\n    & tfoot {\n        text-align: center;\n        & ', ' {\n          margin-top: 10px;\n        }\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Buttons = require('./Buttons');

var _Ribbon = require('./Ribbon');

var _styles = require('./styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var monthlyPrice = function monthlyPrice(offer) {
  return offer.price / offer.frequency;
};
var comparativePrice = function comparativePrice(reference, offer) {
  return reference.price * offer.frequency;
};

var DetailsPrice = (0, _styledComponents2.default)(function (_ref) {
  var className = _ref.className,
      offer = _ref.offer,
      period = _ref.period,
      compareTo = _ref.compareTo,
      children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'strong',
        null,
        monthlyPrice(offer).toFixed(0),
        ' \u20AC'
      ),
      '/',
      period,
      compareTo && _react2.default.createElement(
        'span',
        null,
        comparativePrice(compareTo, offer),
        ' \u20AC'
      )
    ),
    compareTo && _react2.default.createElement(
      'small',
      null,
      children,
      ' (',
      offer.price,
      ' \u20AC)'
    )
  );
})(_templateObject);

var Details = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    props.offer.claim && _react2.default.createElement(
      _Ribbon.Ribbon,
      null,
      props.offer.claim
    ),
    _react2.default.createElement(
      'strong',
      null,
      props.offer.name
    ),
    _react2.default.createElement(DetailsPrice, { offer: props.offer,
      period: props.period,
      compareTo: props.compareTo,
      children: props.children })
  );
})(_templateObject2, _Ribbon.Ribbon);

var checkMark = function checkMark(feature) {
  return 'https://lib.tutellus.com/images/icons/' + (feature ? 'check-green' : 'not-included') + '.svg';
};

var SubscriptionFeature = R.compose(R.cond([[R.is(Boolean), function (feature) {
  return _react2.default.createElement(
    'td',
    null,
    _react2.default.createElement('img', { src: checkMark(feature), alt: '' })
  );
}], [R.T, function (feature) {
  return _react2.default.createElement(
    'td',
    { className: 'darkgrey' },
    feature
  );
}]]), R.prop('children'));
var featuresOf = R.compose(R.apply(R.union), R.map(R.compose(R.keys, R.prop('features'))), R.values);

var SubscriptionPricing = exports.SubscriptionPricing = (0, _styledComponents2.default)(function (_ref2) {
  var className = _ref2.className,
      offers = _ref2.offers,
      ctaText = _ref2.ctaText,
      ctaUrl = _ref2.ctaUrl,
      disclaimer = _ref2.disclaimer,
      period = _ref2.period,
      _ref2$MyButton = _ref2.MyButton,
      MyButton = _ref2$MyButton === undefined ? _Buttons.Button : _ref2$MyButton;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'table',
      null,
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('th', null),
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(Details, { period: period,
              offer: offers.monthly })
          ),
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(
              Details,
              { period: period,
                offer: offers.quarterly,
                compareTo: offers.monthly },
              offers.quarterly.by_paying
            )
          ),
          _react2.default.createElement(
            'th',
            null,
            _react2.default.createElement(
              Details,
              { period: period,
                offer: offers.yearly,
                compareTo: offers.monthly },
              offers.yearly.by_paying
            )
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        { cellSpacing: '10' },
        featuresOf(offers).map(function (feature) {
          return _react2.default.createElement(
            'tr',
            { key: feature },
            _react2.default.createElement(
              'td',
              null,
              feature
            ),
            _react2.default.createElement(
              SubscriptionFeature,
              null,
              offers.monthly.features[feature]
            ),
            _react2.default.createElement(
              SubscriptionFeature,
              null,
              offers.quarterly.features[feature]
            ),
            _react2.default.createElement(
              SubscriptionFeature,
              null,
              offers.yearly.features[feature]
            )
          );
        })
      ),
      _react2.default.createElement(
        'tfoot',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('td', null),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              MyButton,
              { href: ctaUrl },
              ctaText
            )
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              MyButton,
              { href: ctaUrl },
              ctaText
            )
          ),
          _react2.default.createElement(
            'td',
            null,
            _react2.default.createElement(
              MyButton,
              { href: ctaUrl },
              ctaText
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      disclaimer
    )
  );
})(_templateObject3, _styles.styles.media.tablet, _styles.styles.media.tablet, _styles.styles.media.laptop, _Buttons.Button);
SubscriptionPricing.displayName = 'SubscriptionPricing';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/SubscriptionPricing.js
// module id = 645
// module chunks = 0